<template>
  <main class="container my-3 text-center">

    <div class="aguarde-container  text-center" v-if="this.loading">
        <div class="spinner-border" role="status"></div>
        <br>
        <span>Aguarde...</span>
    </div>
    <div
      v-if="!loading"
      class="d-flex flex-column"
    >
      <div class="py-2 d-flex flex-column">
        <p class="m-0" style="font-size: 1.5rem;">{{ detail.nome }}</p>
        <p>{{ detail.nomeLoja }}</p>
        <strong style="font-size: 1.35em;">
          R$ {{ formatPrice(detail.valorParcela) }} /
          <span class="text-small text-italic text-lowercase">{{
            detail.periodicidadeTipo
          }}</span>
        </strong>
        <small style="display:block; color: #979797"
          >Data da assinatura:
          {{ data(detail.dateRegistro, "DD/MM/YYYY") }}</small
        >
        <div id="accordion" class="my-4">
          <button
            @click="mostrarDescricao = !mostrarDescricao"
            class="btn btn-link text-uppercase btn-sm"
          >
            Descrição do plano
          </button>
          <div class="card collapse" :class="{ show: mostrarDescricao }">
            <div class="card-body">
              <div class="container">
                <div v-html="detail.descricaoHtml"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="px-4 my-4 alert alert-danger"
        role="alert"
        v-if="mensagemErro"
      >
        {{ mensagemErro }}
      </div>
      <div
        v-if="idPlanoAssinatura > 0"
        class="d-flex flex-column flex-lg-row justify-content-between"
      >
        <button
          @click="goTo('pagamento')"
          class="btn btn-secondary py-2 px-lg-5 mt-4"
        >
          Voltar
        </button>
        <button
          class="btn btn_color_system py-2 px-lg-5 mt-4"
          @click="handleShowTermos()"
        >
          Assinar
          <span class="spinner-border grey ml-2" v-if="loading"></span>
        </button>
      </div>
    </div>
  </main>
</template>

<script>
import { APIService } from "../../APIService";
const apiService = new APIService();

export default {
  name: "StepPagamento",
  components: {},
  props: ["idAssinatura", "idPlanoAssinatura"],

  data() {
    return {
      pagamentos: [],
      detail: {},
      codigoRecorrencia: "",
      showTermos: false,
      termosLido: false,
      loading: false,
      mensagemErro: "",
      mostrarDescricao: false
    };
  },
  methods: {
    data(data) {
      return this.$moment(data).format("DD/MM/YYYY");
    },
    formatPrice(value) {
      let val = ((value || 0) / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    goToStep(step) {
      this.$emit("goToStep", step);
    },
    aceitarPagamento() {
      this.loading = true;
      apiService
        .aceitarPagamento(this.detail)
        .then(() => {
          this.loading = false;
          this.$swal({
            title: "Parabéns!!!",
            text:
              "Sua assinatura foi realizada com sucesso. Em breve você receberá um e-mail com os detalhes da sua assinatura.",
            confirmButtonText: "Minhas assinaturas",
            preConfirm: () => this.$router.push(`/assinaturas`)
          });
          if (window.PIXEL_CODE) {
            window.fbq("track", "Purchase", {
              value: this.detail.valorParcela,
              currency: "BRL",
              predicted_ltv: "0.00",
              content_name: this.detail.nome
            });
          }
        })
        .catch(() => {
          this.mensagemErro =
            "Ocorreu um problema ao processar sua assinatura, tente novamente.";
            this.loading = false;
        });
    },
    handleShowTermos() {
      this.$swal({
        title: "Termos e condições",
        html: `<div style="overflow: auto;max-height: 70vh;">${this.detail.termos}</div>`,
        confirmButtonText: "Aceitar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        preConfirm: () => this.aceitarPagamento()
      });
    }
  },
  mounted() {
     this.loading = true;
    apiService
      .obterDetalhePagamentoRecorrente(this.idPlanoAssinatura)
      .then((response) => {
          this.loading = false;
        this.detail = response;
      });
  }
};
</script>
<style scoped lang="scss"></style>
